import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ServiceOffert = lazy(() => import("@/pages/offert/ServiceOffert"));

export const Route = createFileRoute("/laddboxar/offert")({
  head: () => seoHead("/laddboxar/offert"),
  component: () => <ServiceOffert service="laddboxar" />,
});
